<!-- @format -->

@if (shouldDisplayShippingMessages()) {
	<div
		id="pdp-shipping-container"
		class="top-border hmf-mb-s hmf-mb-m-m hmf-mt-xxs hmf-pb-m hmf-px-s hmf-px-m-0">
		<div class="product-shipping-header hmf-text-transform-uppercase">Shipping Information</div>
		<div class="product-shipping-container">
			@for (shippingMessage of shippingMessages(); track trackByFn($index, shippingMessage)) {
				<!-- panel cover -->
				@if (shippingMessage?.show) {
					<div class="shipping-description-text-container">
						<button
							class="shipping-description-text"
							(click)="loadBodyContent(shippingMessage)"
						>
							@if (shippingMessage?.date && preOrderEnabled()) {
								<homefield-icon
									width="16px"
									height="16px"
									class="pre-order-messaging-icon"
									name="alert-error-outlined"
								></homefield-icon>
							}
							@if (shippingMessage?.showImage && !shippingMessage?.date && !shippingInfo()?.isPreSale) {
								<img
									class="product-shipping-img"
									[ngClass]="shippingMessage?.imageClass"
									[src]="shippingMessage?.image"
									alt=""
									aria-hidden="true"
									loading="lazy" />
							}
							{{ shippingMessage?.message }}
						</button>
						<div class="shipping-description-text-sub-message">
							{{ shippingMessage?.subMessage }}
							{{
								shippingMessage?.date && preOrderEnabled()
									? (shippingMessage?.date | date: 'EEE, MMM d')
									: ''
							}}
						</div>
					</div>
				}
			}
		</div>
	</div>
}

<ng-template #drawerContent>
	<div
		class="hmf-p-s hmf-p-md-m overflow-y-auto"
		[innerHTML]="currentShippingMessage()?.innerHtml | bypassSanitization"
	></div>
</ng-template>
